import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "info-panel cookies-info-box"
};
const _hoisted_2 = { class: "d-grid d-sm-block" };
const _hoisted_3 = ["textContent"];
const _hoisted_4 = ["textContent"];
const _hoisted_5 = {
    class: "info-panel-details",
    ref: "details"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
            (!_ctx.cookies.closed.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "default"),
                    _renderSlot(_ctx.$slots, "actions", {
                        accept: () => _ctx.cookies.accept(),
                        acceptAll: () => _ctx.cookies.acceptAll(),
                        close: () => _ctx.cookies.close(),
                        categories: _ctx.cookies.categories,
                        toggleDetails: _ctx.toggleDetails
                    }, () => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary me-sm-half mb-half mb-sm-0",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.cookies.close && _ctx.cookies.close(...args))),
                                textContent: _toDisplayString(_ctx.$t('cookies.button.close'))
                            }, null, 8, _hoisted_3),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.cookies.accept && _ctx.cookies.accept(...args))),
                                textContent: _toDisplayString(_ctx.$t('cookies.button.accept'))
                            }, null, 8, _hoisted_4)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "details")
                    ], 512)
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 3
    }));
}
